import React, {useState} from "react"
import styles from "./index.module.scss"

interface IDescription {
  value: string
  onSave: (val: string) => void
}

/**
 * TODO - do we need to disable the button when it is sending request?
 * TODO - string validation
 * @param {IDescription} param
 * @param param.value Description
 * @param param.onSave click handler on save button
 * @returns
 */
export const Description: React.FC<IDescription> = ({value, onSave}) => {
  const [desc, setDesc] = useState<string>(value)

  return (
    <div className={styles.Section}>
      <div className={styles.SubHeader}>
        Description (max 100 words)
      </div>
      <div className={styles.SectionRow}>
        <textarea
          className={styles.TextArea}
          placeholder="Repository Description"
          value={desc}
          onChange={(e) => setDesc(e.target.value)}
        />
        <button
          className={styles.DescriptionBtn}
          onClick={() => onSave(desc)}
        >
          Save
        </button>
      </div>
    </div>
  )
}
